import { render, staticRenderFns } from "./userGroupSelector.vue?vue&type=template&id=7b5ba479&"
import script from "./userGroupSelector.vue?vue&type=script&lang=js&"
export * from "./userGroupSelector.vue?vue&type=script&lang=js&"
import style0 from "./userGroupSelector.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports